import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            探索分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            六大主题，从不同维度解读女仆文化的丰富内涵
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-200 p-6 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-500">
                浏览文章
                <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}